import styled from 'styled-components';
import { DropdownToggle, DropdownMenu, DropdownItem } from 'reactstrap';

export const CountryBox = styled.div`
  display: flex;
  flex-basis: 33.33%;
  padding: 10px 20px 10px 10px;
  background-color: transparent;

  @media (min-width: 576px) {
    background-color: ${props => (props.active ? '#edf9ff' : 'transparent')};
  }
`;

export const DropdownToggleCustom = styled(DropdownToggle)`
  background-color: transparent;
  color: #000;
  border: none;
  padding: 0;
  text-transform: capitalize;
  height: 25px;
  font-size: 14px;
  line-height: 1;
  display: flex;
  align-items: center;

  @media (min-width: 576px) {
    font-size: 0.875rem;
  }

  &.btn-secondary {
    &[aria-expanded='true'],
    &:hover,
    &:active {
      background-color: transparent;
      color: #007db8;
      border: none;
      box-shadow: none;
    }

    &:focus,
    &:focus:active {
      background-color: transparent;
      color: #007db8;
      border: none;
      box-shadow: none;
      outline: 1px dotted #212121;
      outline: 5px auto -webkit-focus-ring-color;
    }
  }
`;

export const DropdownMenuCustom = styled(DropdownMenu)`
  border: 1px solid #00447c;
  background-color: #fff;
  box-shadow: 1px 1px 3px 0 rgba(0, 0, 0, 0.15);
  margin: 0;
  padding: 0;
  min-width: 100px;
  margin-left: 35px;
`;

export const DropdownItemCustom = styled(DropdownItem)`
  color: #007db8;
  padding: 5px;
  margin: 0;
  max-width: 100%;
  font-size: 14px;

  @media (min-width: 576px) {
    font-size: 0.875rem;
  }

  &:hover,
  &:focus,
  &:focus:active,
  &:active {
    background-color: #007db8;
    color: #fff;
    border: none;
    box-shadow: none;
  }
`;

export const AngleDownIcon = styled.span`
  transform: rotate(90deg);
  display: inline-block;
  font-size: 12px;

  @media (min-width: 576px) {
    font-size: 0.875rem;
  }

  margin-left: 3px;
  position: relative;
  top: 1px;
`;

export const FlagImage = styled.img`
  display: inline-block;
  max-width: 100%;
  max-height: 25px;
  margin-right: 10px;
`;

export const CountryButton = styled.button`
  border: none;
  outline: none;
  box-shadow: none;
  font-size: 14px;
  color: #000;
  padding: 10px 20px;
  line-height: 20px;
  background: transparent;
  padding: 0;
  display: flex;
  align-items: center;

  &:focus,
  &:hover {
    box-shadow: none;
    color: #007db8;

    span.text {
      text-decoration: underline;
    }
  }
`;
